import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SelectModule } from 'primeng/select';

interface Language {
  code: string;
  name: string;
  flag: string;
}

@Component({
  selector: 'app-language-selector',
  imports: [
    FormsModule,
    TranslateModule,
    SelectModule
],
  templateUrl: './language-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {

  languages: Language[] = [
    { code: 'fr', name: 'Français', flag: 'assets/images/flags/france.svg' },
    { code: 'en', name: 'English', flag: 'assets/images/flags/usa.svg' },
    { code: 'es', name: 'Español', flag: 'assets/images/flags/spain.svg' }
  ];

  selectedLanguage: Language = this.languages[0];

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    const currentLang = this.translateService.currentLang || 'fr';
    this.selectedLanguage = this.languages.find(lang => lang.code === currentLang) || this.languages[0];
  }

  onLanguageChange(event: any): void {
    const selectedLang = event.value;
    this.selectedLanguage = selectedLang;
    this.translateService.use(selectedLang.code);
    localStorage.setItem('language', selectedLang.code);
  }
} 